import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/devpath-ai/devpath-ai/app/mistakes/MistakeBookClient.tsx");
